module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio', _vm._g(_vm._b({
    staticClass: "rt-radio"
  }, 'el-radio', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f8ea72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/radio/rtRadio.vue
// module id = 2171
// module chunks = 228